import { useSelector } from 'react-redux';
import type { RootState } from '/business/shared/state/store';
import getApplicationReportingStartDateSelector from '/business/shared/state/selectors/application/model/getApplicationReportingStartDateSelector';
import getApplicationReportingEndDateSelector from '/business/shared/state/selectors/application/model/getApplicationReportingEndDateSelector';
import type { ElectricityHeatSteamRenewableCertificate } from '/business/shared/state/selectors/application/electricityHeatSteam/electHeatSteamTypes';
import { useCallback } from 'react';

export default function useValidateCertificateDateRange() {
  const reportingStartDate = useSelector((state: RootState) => getApplicationReportingStartDateSelector(state)) || null;
  const reportingEndDate = useSelector((state: RootState) => getApplicationReportingEndDateSelector(state)) || null;

  return useCallback(
    (cert?: ElectricityHeatSteamRenewableCertificate | null, startDateOverride?: Date, endDateOverride?: Date) => {
      const baseDateStart = new Date(reportingStartDate as string);
      const baseDateEnd = new Date(reportingEndDate as string);

      const startDateRange = startDateOverride ? startDateOverride : new Date();
      const endDateRange = endDateOverride ? endDateOverride : new Date();
      if (!startDateOverride && cert) {
        startDateRange.setFullYear(cert.date_range_start_year || 0, cert.date_range_start_month, 1);
      }
      if (!endDateOverride && cert) {
        endDateRange.setFullYear(cert.date_range_end_year || 0, cert.date_range_end_month, 1);
      }
      startDateRange.setHours(0);
      startDateRange.setMinutes(0);
      startDateRange.setSeconds(0);
      if (startDateRange > endDateRange) {
        return false;
      }
      return (
        startDateRange.getTime() <= baseDateEnd.getTime() && endDateRange.getTime() - 86400 >= baseDateStart.getTime()
      );
    },
    [reportingStartDate, reportingEndDate],
  );
}
